import React, { Component } from 'react';
import { AutomaticPlayerControls } from './Components/Controls/AutomaticPlayerControls';
import { DeckGrid } from './Components/Views/DeckBar';
import { ManualPlayerControls } from './Components/Controls/ManualPlayerControls';
import TheRiver from './Components/Controls/TheRiver';

import './game-player.css';
import { HOTEL_BOARDS_URL } from '../../Settings';

const OPEN_ID = 15;
const LOBBY_ID = 16;
const STARTING_ID = 1;
// const STARTED_ID = 2;
const PRE_START = [OPEN_ID, LOBBY_ID, STARTING_ID];
// 2026-05-16: Game-player status meaning "this seat owes us its
// Manual-3.2 second-Lodging choice." The backend's Initial Lodging
// Round (see engine/round_choices/initial_lodging_round.py) sets
// every seat to this status at game start and walks through them
// one at a time, but it never sends a Choice payload for human
// players — the ChoiceRouter pipeline that used to dispatch
// CHOICE_COMPONENTS[33] was gutted. Render the picker directly
// when this seat is the current_player and still in GAME_SETUP.
const GAME_SETUP_ID = 25;

function isPreGameStart(gameData) {
    return (PRE_START.includes(gameData.status));
}


function HotelBackground(props) {
    let factionId = props.gamePlayerData.faction;
    if (factionId === null) return <></>
    let factionShips = [ null, 2, 3, 4, 5, 6, 7 ];
    let shipId = factionShips[factionId];
    let ship = props.app.gameController.library.shipLibrary.ships[shipId];
    let enabled = props.app.state.authenticator.account.high_quality_textures;
    let src = HOTEL_BOARDS_URL;
    if (enabled) {
        let highRes = ship.assets.four_k_2d;
        src += highRes;
    } else {
        let lowRes = ship.assets.low_resolution_2d;
        src += lowRes;
    }
    return <div id={'hotel-background-anchor'} className={'hotel-background-anchor'}>
        <img alt={'hotel'} src={src}
             className={'hotel-background'}
        />
    </div>;
}


export default class GamePlayer2d extends Component {

    render() {
        if (!this.props.gamePlayerData) {
            return <></>;
        }
        let _isPreGameStart = isPreGameStart(this.props.gameData);
        if (_isPreGameStart) return <></>
        let gamePlayerData = this.props.gamePlayerData;
        let isActivePlayer = this.props.gameData.active_player === gamePlayerData.id;
        let isMyInitialLodgingTurn = (
            gamePlayerData.status === GAME_SETUP_ID &&
            this.props.gameData.current_player === gamePlayerData.id);
        let props = {
            gamePlayerData: gamePlayerData,
            isPreGameStart: _isPreGameStart,
            isActivePlayer: isActivePlayer,
            isMyInitialLodgingTurn: isMyInitialLodgingTurn,
            ...this.props
        };

        return (<div id={'GamePlayer2d'}>
                <div>
                    <div id={'dick grid'}>
                        <DeckGrid {...this.props} />
                    </div>
                </div>
                <div className={'game-player-controllers'}>
                    <AutomaticPlayerControls {...this.props} />
                    <TheRiver {...this.props} bind={true}/>
                    <ManualPlayerControls {...props}/>
                </div>



                {/* <div id={'game-player-controls'} */}
                {/*      className="game-player-controls"> */}
                {/*     <div id={'game-player-board-holder'} */}
                {/*          className={'game-player-control-column'} */}
                {/*     > */}
                {/*         /!* <TopLeftButton {...props} /> *!/ */}
                {/*         /!* {isActivePlayer && *!/ */}
                {/*         /!*     <BigButton {...props}>Next</BigButton> *!/ */}
                {/*         /!* } *!/ */}
                {/*         /!* <MessageDisplay {...props}/> *!/ */}

                {/*         /!* <HotelBackground {...props} /> *!/ */}


                {/*         <GamePlayerBoard {...props}/> */}
                {/*     </div> */}
                {/*     <div id={'game-player-menu-column'} */}
                {/*          className={'game-player-control-column'} */}
                {/*     > */}

                {/*         /!* <PlayerStorage2d {...props}/> *!/ */}

                {/*         /!* <GamePlayerPools2d {...props}/> *!/ */}

                {/*         <ScoreBars {...this.props}/> */}
                {/*     </div> */}
                {/* </div> */}
            </div>
        );
    }

}
